/**
 * 儲存到使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 * @param {String} data data
 */
function saveLocalData(key, data) {
  localStorage.setItem(key, data);
}

/**
 * 取得使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 * @return {String} 取得的值
 */
function getLocalData(key) {
  return localStorage.getItem(key);
}

/**
 * 刪除使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 */
function removeLocalData(key) {
  localStorage.removeItem(key);
  document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/**
 * 設定限時儲存使用者端本地資料
 * @param {String} key key
 * @param {String} data key
 * @param {String} expiry key
 */
function setTemporaryData(key, data, expiry) {
  const item = {
    data,
    expiry: Number(expiry),
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * 取得限時使用者端本地資料
 * @param {String} key key
 * @return {String} 取得的值
 */
function getDataWithExpiry(key) {
  let item = localStorage.getItem(key);
  if (!item) {
    return null;
  }
  item = JSON.parse(item);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.data;
}

export {
  saveLocalData,
  getLocalData,
  removeLocalData,
  setTemporaryData,
  getDataWithExpiry,
};
